import { createListSlice } from 'redux/utils'

const slice = createListSlice('ComicCollection')
export const { actions } = slice
export default slice.reducer
